module.exports = __webpack_public_path__ + "static/367117_2_0-75afb1e44d0cda8342bab3350ff6477c.woff";